import { FileVersion } from "../fileversion";
import { ApiRoutesDictionary } from "./api-routes-dictionary";

/**
 * Contains information about the REST API.
 */
export interface IApiInfo {
    /**
     * Gets the file version of the Content Hub API.
     */
    readonly fileVersion: FileVersion;
    /**
     * Gets the minimum supported SDK version.
     */
    readonly minimumSdkVersion: FileVersion;
    /**
     * A dictionary containing the API routes.
     * Contents: route name -\> route link.
     */
    readonly routes: ApiRoutesDictionary;
}

/**
 * {@inheritDoc}
 */
export class ApiInfo implements IApiInfo {
    readonly fileVersion: FileVersion;

    readonly minimumSdkVersion: FileVersion;

    readonly routes: ApiRoutesDictionary;

    constructor(fileVersion: FileVersion, minimumSdkVersion: FileVersion, routes: ApiRoutesDictionary) {
        this.fileVersion = fileVersion;
        this.minimumSdkVersion = minimumSdkVersion;
        this.routes = routes;
    }
}
